<template>
  <div class="app-reset-password-confirm-password">
    <slot name="txtBefore">
      <p>
        Bitte vergeben Sie nun ihr neues Passwort.
        <br />
        Ihr neues Passwort muss aus 6-8 Zeichen bestehen und darf keine Ziffernfolge (1234) oder mehrfach die gleiche
        Ziffer (1111) enthalten
      </p>
    </slot>
    <b-form>
      <b-form-group
        label="Passwort ändern"
        label-class="visually-hidden"
      >
        <b-form-row>
          <b-col sm="12" md="">
            <label class="mandatory" for="newPassword"><slot name="lblNewPassword">Neues Passwort</slot></label>
          </b-col>
          <b-col>
            <b-form-input
              id="newPassword"
              name="newPassword"
              type="password"
              required
              v-model="newPassword"
              @input="$v.newPassword.$touch"
              :state="isValid('newPassword')"
            ></b-form-input>
            <b-form-invalid-feedback>
              <slot name="errorMessagePasswortRules">Ihr Passwort entspricht nicht den Passwort-Regeln</slot>
            </b-form-invalid-feedback>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col sm="12" md="">
            <label class="mandatory" for="newPasswordRepeat">
              <slot name="lblNewPasswordRepeat">Neues Passwort (Wiederholung)</slot>
            </label>
          </b-col>
          <b-col>
            <b-form-input
              id="newPasswordRepeat"
              name="newPasswordRepeat"
              type="password"
              required
              v-model="newPasswordRepeat"
              @input="$v.newPasswordRepeat.$touch"
              :state="isValid('newPasswordRepeat')"
            ></b-form-input>
            <b-form-invalid-feedback>
              <slot name="errorMessagePasswordNotEqual">Ihre Passwörter stimmen nicht überein</slot>
            </b-form-invalid-feedback>
          </b-col>
        </b-form-row>
        <b-form-row>
          <b-col sm="12" md="">
            <label class="mandatory" :for="'birthdate' + _uid">
              <slot name="lblBirthdate">Geburtsdatum</slot>
            </label>
          </b-col>
          <b-col>
            <b-input-group>
              <b-form-input
                :id="'birthdate' + _uid"
                v-model="birthdate"
                type="text"
                name="birthdate"
                required
                :state="isValid('birthdate')"
                @input="$v.birthdate.$touch"
                placeholder="TT.MM.JJJJ"
                autocomplete="off"
              ></b-form-input>
              <b-input-group-append>
                <b-form-datepicker
                  v-bind="calendarSettings || {}"
                  button-only
                  right
                  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                  @input="$v.birthdate.$touch"
                  @context="selectDate"
                  :aria-controls="'birthdate' + _uid"
                ></b-form-datepicker>
              </b-input-group-append>
              <b-form-invalid-feedback>
                <slot name="errorMessageBirthdate">Bitte geben Sie Ihren Geburtstag an</slot>
              </b-form-invalid-feedback>
            </b-input-group>
          </b-col>
        </b-form-row>
      </b-form-group>
      <b-overlay class="btn-next-overlay" :show="loading" spinner-small>
        <b-button class="btn-next" type="button" variant="primary" :disabled="$v.$invalid || loading" v-on:click="save">
          <slot name="btnPasswordNext">weiter</slot>
        </b-button>
      </b-overlay>
    </b-form>
    <slot name="txtAfter">
    </slot>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, sameAs } from 'vuelidate/lib/validators'
import { mapMutations, mapActions } from 'vuex'
import { validDate, validDateFormat } from '@/validators/date'
import { BFormGroup, BForm, BButton, BFormRow, BCol, BFormInput, BFormInvalidFeedback, BFormDatepicker, BInputGroup, BInputGroupAppend, BOverlay } from 'bootstrap-vue'
import isValid from '../../../../../mixins/isValid'

export default {
  name: 'ResetPasswordConfirmationPassword',
  data: function () {
    return {
      brand_: null,
      newPassword: '',
      newPasswordRepeat: '',
      birthdate: null,
      loading: false
    }
  },
  computed: {
    calendarSettings () {
      return this.$config.calendar.calendarSettings
    }
  },
  created () {
    this.brand_ = this.$store.getters.brand
  },
  components: {
    BFormGroup, BForm, BButton, BFormRow, BCol, BFormInput, BFormInvalidFeedback, BFormDatepicker, BInputGroup, BInputGroupAppend, BOverlay
  },
  mixins: [validationMixin, isValid],
  methods: {
    selectDate (ctx) {
      if (ctx.selectedDate) {
        this.birthdate = ctx.selectedFormatted
      }
    },
    async save () {
      this.loading = true
      await this.resetPassword({ password: this.newPassword, birthdate: this.birthdate })
      this.loading = false
    },
    ...mapActions('resetPassword', [
      'resetPassword'
    ]),
    ...mapMutations('resetPassword', [
      'finalizeProcess'
    ])
  },
  validations () {
    return {
      newPassword: {
        required,
        passwordValidation: this.$config?.validation?.validatePassword
      },
      newPasswordRepeat: {
        sameAsPassword: sameAs('newPassword')
      },
      birthdate: {
        required,
        validDate,
        validDateFormat
      }
    }
  }
}
</script>
